import { FunctionComponent } from 'react';

import {
  StandardTextSpaced,
  StrongTextSpaced,
} from 'chime-ui/components/Typography';

const RFAFAQText: FunctionComponent = () => (
  <>
    <StrongTextSpaced>What are Pay Anyone Transfers?</StrongTextSpaced>
    <StandardTextSpaced>
      When you receive a text or email about a Pay Anyone Transfer, you can
      instantly transfer those funds directly to a Chime member fee-free. When
      you successfully send the Pay Anyone Transfer; the funds are transferred
      from the bank account associated with the debit card information you
      provided.
    </StandardTextSpaced>
    <StrongTextSpaced>Are they really instant?</StrongTextSpaced>
    <StandardTextSpaced>
      Instant transfers can be used to send Pay Anyone Transfers to Chime
      members 24 hours a day, 365 days a year, regardless of holiday or weekend
      schedules. However, Pay Anyone Transfers may be affected by circumstances
      beyond our control (such as fire, flood, power failure, strike, labor
      dispute, critical service provider failure, computer breakdown, telephone
      line disruption, government or regulatory action, or a natural disaster),
      despite reasonable precautions that we have taken.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Additionally, Pay Anyone Transfers are reviewed and could be declined,
      delayed, or blocked if the transfer could result in fraud or another form
      of financial harm. We may request that you provide additional information
      to verify your identity.
    </StandardTextSpaced>
    <StrongTextSpaced>
      What limits are there on sending Pay Anyone Transfers?
    </StrongTextSpaced>
    <StandardTextSpaced>
      There are daily, weekly, and monthly limits to the number of and the
      amount of Pay Anyone Transfers you can send.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Chime members also have limits in the amount and frequency that they can
      receive Pay Anyone Transfers from non-Chime members.
    </StandardTextSpaced>
    <StrongTextSpaced>Can I cancel a Pay Anyone Transfer?</StrongTextSpaced>
    <StandardTextSpaced>
      Your Pay Anyone Transfer will only be complete when you tap or click the
      Pay button. Once you tap or click the Pay button, you will not be able to
      cancel the transfer. You’ll receive a confirmation email and confirmation
      in the web page that your funds were sent.
    </StandardTextSpaced>
    <StrongTextSpaced>
      How do I know if I have an eligible bank account or debit card?
    </StrongTextSpaced>
    <StandardTextSpaced>
      You can only send Pay Anyone Transfers with U.S. bank issued debit cards.
      Credit cards, prepaid cards, and debit cards issued by foreign banks
      cannot be used to send funds.
    </StandardTextSpaced>
    <StrongTextSpaced>
      Why did I get an error when I tried to instantly transfer funds from my
      bank account?{' '}
    </StrongTextSpaced>
    <StandardTextSpaced as="span">
      Instant transfers can be reviewed and declined for a variety of reasons,
      including Chime’s automated internal security measures. Here are some
      common reasons why you might be receiving an error message:
      <ol>
        <li>Is your name on the card you used?</li>
        <li>Did you enter your debit card information correctly?</li>
        <li>Is your debit card expired?</li>
        <li>
          Does the ZIP code you entered match the ZIP code on file with your
          debit card?
        </li>
        <li>Did you enter credit card information?</li>
        <li>Did you enter prepaid information?</li>
        <li>Did you enter a foreign bank issued debit card information?</li>
        <li>
          Has it been more than 14 days since the Pay Anyone Transfer was sent?
        </li>
        <li>Have you already claimed these funds?</li>
        <li>
          Does this Pay Anyone Transfer place you over a non-member recipient
          dollar limit?
        </li>
      </ol>
    </StandardTextSpaced>
    <StandardTextSpaced>
      If you continue to receive an error message, try again later or try again
      using a different card.
    </StandardTextSpaced>
    <StandardTextSpaced>
      If that doesn’t work, this feature might be unavailable to you, even if
      you’ve used a debit card for instant transfers successfully in the past.
    </StandardTextSpaced>
    <StrongTextSpaced>
      How do I check on the status of an instant transfer?
    </StrongTextSpaced>
    <StandardTextSpaced>
      After you have successfully provided a valid name, email address, and U.S.
      bank issued debit card information for the transfer, you will receive a
      confirmation on the web page and an email letting you know whether the
      transfer was successful.
    </StandardTextSpaced>
    <StandardTextSpaced>
      You can also check your account transactions or statements to see if your
      account was debited. If you don’t see the transaction, you should contact
      the bank that issued the debit card you used. When you contact them, it’s
      important to explain that the money will appear as an original credit
      transaction (AFT) or a real-time payment, not a missing ACH/direct
      deposit.
    </StandardTextSpaced>
  </>
);

export default RFAFAQText;
